<div class="spinner">
  <div
    [style.transform]="'scaleX(' + (httpStatus.progress | async) + ')'"
    [ngClass]="{ 'spinner__bar': true, 'spinner__bar--complete': (httpStatus.progress | async) === 1 }"
    role="progressbar"></div>
</div>
